module.exports = __webpack_public_path__ + "img/icon_slabs.dee67142.svg";